import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { InfoLinks } from "../../types";

export const useInfoLinks = () => {
  const { i18n } = useTranslation();

  const links: InfoLinks = useMemo(() => {
    try {
      return JSON.parse(process.env.REACT_APP_INFO_LINKS || "{}");
    } catch {
      console.error(
        "Invalid links configuration provided, make sure that REACT_APP_INFO_LINKS is a valid JSON string."
      );
      return {};
    }
  }, []);

  const result = links[i18n.language as keyof typeof links];

  if (!result) {
    console.error(
      `No links configuration found for language ${i18n.language}, falling back to en.`
    );
    return links.en || {};
  }

  return result;
};
